import React from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { get } from "lodash";
import GeneralRadio from "./GeneralRadio";

interface GenderSelectProps {
  name: string;
  required?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  className?: string;
}

const GenderRadioSelect: React.FC<GenderSelectProps> = ({
  name,
  required = false,
  disabled,
  className,
  readOnly,
}) => {
  const { t } = useTranslation();
  const {
    register,
    setValue,
    watch,
    clearErrors,
    formState: { errors },
  } = useFormContext();

  const selectedGender = watch(name, undefined);

  const handleGenderChange = (gender?: string) => {
    clearErrors(name);
    setValue(name, gender);
  };

  const error = get(errors, name);
  const errorMessage =
    error && error.message
      ? typeof error.message === "string"
        ? error.message
        : String(error.message)
      : undefined;
  return (
    <div className="relative">
      <div
        className={`flex w-full items-center justify-between gap-4 rounded-lg px-4 py-2.5 ${readOnly ? "border border-systemBg bg-primary-bg" : "bg-primary-bg"} ${className}`}
      >
        <p>{t("gender")}</p>
        <div className="flex items-center gap-8">
          <GeneralRadio
            name={name}
            label={t("male")}
            value="Male"
            checked={selectedGender === "Male"}
            disabled={disabled || readOnly}
            onClick={() => handleGenderChange("Male")}
            labelStyle={`${readOnly ? "!text-body-text" : "!text-primary-text"} !font-normal`}
            onChange={(event) => {}}
          />
          <GeneralRadio
            name={name}
            label={t("female")}
            value="Female"
            checked={selectedGender === "Female"}
            disabled={disabled || readOnly}
            onClick={() => handleGenderChange("Female")}
            labelStyle={`${readOnly ? "!text-body-text" : "!text-primary-text"} !font-normal`}
            onChange={(event) => {}}
          />
        </div>
      </div>
      <input
        type="hidden"
        {...register(name, {
          required: {
            value: required,
            message: t("required_field"),
          },
        })}
      />
      {errorMessage && <p className="text-xs text-error">{errorMessage}</p>}
    </div>
  );
};

export default GenderRadioSelect;
